"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./browser"), exports);
var common_1 = require("./common");
Object.defineProperty(exports, "disableConsoleLogForTest", { enumerable: true, get: function () { return common_1.disableConsoleLogForTest; } });

//# sourceMappingURL=index.browser.js.map
